<template>
  <div class="visa page-bg">
    <div class="visa_top">
      <van-swipe class="topImg" :autoplay="3000">
        <van-swipe-item v-for="(image, index) in bannerImages" :key="index">
          <img class="topImg_img" :src="image" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="body">
      <div class="content">
        <div
          v-if="isShowSelectCity"
          class="address_box"
          @click="showPicker = true"
        >
          <img class="img_one" src="../../assets/homeImgs/dw.png" alt="" />
          <div class="address_text">
            常驻地:
            {{ addressObj.length > 0 ? addressObj[0].name : "不限" }}
          </div>
          <div class="address_value">
            <!-- {{ cityName }} -->
          </div>
          <img class="img_two" src="@/assets/home/downIcon.png" alt="" />
        </div>
        <div class="visa_list">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <div
                class="list_box"
                v-for="(item, index) in visaList"
                :key="index"
                @click="productCellClick(item)"
              >
                <img
                  class="images"
                  :src="getFilePath(getPicFromImages(item.images))"
                />
                <div class="content_box">
                  <div class="content_Name text_line_3">
                    {{ item.productName }}
                  </div>
                  <div class="contents_box">
                    <div class="contents">
                      签证地：{{ getVisaAddress(item) }}
                    </div>
                    <div class="contents">
                      送签地：
                      {{ getVisaCity(item.deliveryCity) }}
                    </div>
                    <div class="contents">供应商：{{ item.supplierName }}</div>
                  </div>
                  <div class="content_price">
                    ¥<span>{{ getPrice(item) }}</span> 起
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
          <!-- </van-tab>
          </van-tabs> -->
        </div>
      </div>
    </div>
    <!-- <van-popup
      ref="popup"
      v-model="showPicker"
      round
      position="bottom"
      :style="{ height: '50%' }"
    >
      <van-list class="van-list-box">
        <van-cell v-for="(item, index) in addressList" :key="index">
          <div @click="selectAddress(item)" class="cellView">
            {{ item.dictLabel }}
          </div>
        </van-cell>
      </van-list>
    </van-popup> -->
    <van-popup
      position="bottom"
      round
      :close-on-click-overlay="false"
      v-model="showPicker"
    >
      <van-area
        title="城市选择"
        :area-list="areaList"
        :columns-num="1"
        @confirm="confirm"
        @cancel="cancel"
      />
    </van-popup>
  </div>
</template>

<script>
import { getImgUrl } from "@/mixins/getImgUrl";
import area from "@/lib/area.js";
export default {
  name: "visa-goods",
  mixins: [getImgUrl],
  data() {
    return {
      active: 0,
      // tabs: ["全部", "旅游签", "商务签", "探亲访友签"],
      bannerImages: [
        require("@/assets/visa_1.jpeg"),
        require("@/assets/visa_2.jpeg"),
      ],
      visaList: [],
      loading: false,
      finished: false,
      refreshing: false,
      productId: "",
      addressObj: [],
      addressList: [],
      nationList: [],
      page: {
        pageNum: 0,
        pageSize: 10,
      },
      showPicker: false,
      isShowCitySelect: false,
      areaList: area,
      isShowSelectCity: false,
    };
  },
  created() {
    this.productCode = this.$route.query.productCode;
    this.productId = this.$route.query.productId;
    this.nationList = JSON.parse(localStorage.getItem("nationList"));
    var address = JSON.parse(sessionStorage.getItem("city"));
    if (address && address.length > 1) {
      var provinceCode = address[1].code.toString().substr(0, 2) + "0000";
      address[0].code = provinceCode;
      // var cityCode = address[1].code.toString().substr(0, 4) + "00";
      // address[1].code = cityCode;
      this.addressObj = address;
    }

    // this.queryProdcutById();
  },
  methods: {
    confirm(item) {
      console.log(item);
      this.addressObj = item;
      this.onRefresh();
      this.cancel();
    },
    cancel() {
      this.showPicker = false;
    },
    getVisaAddress(item) {
      var startAddress = "";
      var endAddress = "";
      this.nationList.forEach((e) => {
        if (e.dictValue === item.visaPlaceZhou) {
          startAddress = e.dictLabel;
        }
        if (e.dictValue === item.visaPlaceNation) {
          endAddress = e.dictLabel;
        }
      });
      return startAddress + " - " + endAddress;
    },
    getVisaCity(item) {
      return area.city_list[item];
    },
    getPicFromImages(images) {
      if (images.length > 0) {
        return images[0].filePath;
      }
      return "";
    },
    getPrice(item) {
      return this.$store.getters.identityDeal
        ? item.productMarketPrice
        : item.productDistributionPrice;
    },
    //返回
    backToLast() {
      this.$router.go(-1);
    },
    //查询某个地方的产品信息
    queryProdcutById() {
      var params = {
        pageSize: this.page.pageSize,
        pageNum: this.page.pageNum,
        visaPlaceNation: this.$route.query.visaPlaceNation,
        visaPlaceZhou: this.$route.query.visaPlaceZhou,
      };
      // if (this.addressObj.length > 0) {
      // 	// params.deliveryCity = this.addressObj[0].code;
      // 	params.serviceRegion = this.addressObj[0].code
      // }
      this.$API.x_person.buyProductList(params).then((res) => {
        this.finished = false;
        if (this.page.pageNum == 0) {
          this.visaList = res.data.list;
        } else {
          this.visaList = this.visaList.concat(res.data.list);
        }
        if (res.data.list.length < this.page.pageSize) {
          this.finished = true;
        }
        this.page.pageNum = this.page.pageNum + 1;
        this.refreshing = false;
        this.loading = false;
      });
      // try {
      //     this.$API.x_person.buyProductList({productId:this.productId}).then((res) => {
      //         this.visaList =  res.data;
      //         this.refreshing = false;
      //         this.loading = false;
      //         this.finished = true;
      //     });
      // } catch (e) {
      //     this.$toast('查询失败' + e);
      //     this.refreshing = false;
      //     this.loading = false;
      //     this.finished = true;

      // }
    },

    changeTab() {},
    onLoad() {
      this.queryProdcutById();
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.page.pageNum = 0;
      this.queryProdcutById();
    },
    productCellClick(item) {
      this.$router.push({
        path: "/visa/visa_detail_new",
        query: {
          productCode: item.productCode,
          productId: item.productId,
          serviceRegion: this.$route.query.serviceRegion,
          province: this.$route.query.province,
          minPrice: item.productMarketPrice,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.visa {
  background-color: #f4f6f9;
  height: 100%;
  padding-bottom: vw(160);

  .visa_top {
    position: relative;
    width: 100%;
    height: vw(450);
    .topImg {
      width: 100%;
      height: vw(450);
      .topImg_img {
        object-fit: contain;
      }
    }
    // background: url("../../assets/homeImgs/person_top_bg.png") no-repeat; //no-repeat 不重复
    // background-size: 100% 100%; //适配宽高
  }

  .body {
    // margin-top: vw(-38);
    .content {
      .address_box {
        width: 100%;
        height: vw(110);
        background-color: #ffffff;
        display: flex;
        flex-direction: row;
        align-items: center;

        .img_one {
          width: vw(42);
          height: vw(42);
          margin-left: vw(32);
        }

        .address_text {
          margin-left: vw(8);
          font-size: vw(30);
          font-family: Source Han Sans CN;
          color: #333333;
          opacity: 1;
        }

        .address_value {
          margin-left: vw(8);
          font-size: vw(30);
          font-family: Source Han Sans CN;
          color: #333333;
          opacity: 1;
        }

        .img_two {
          width: vw(13);
          height: vw(8);
          margin-left: vw(8);
        }
      }

      .visa_list {
        margin-top: vw(2);
        // height: vw(91);
        // background-color: #ffffff;

        .list_box {
          margin-top: vw(24);
          margin-left: vw(32);
          margin-right: vw(32);
          padding: vw(20);
          background-color: #ffffff;
          border-radius: vw(12);
          display: flex;
          flex-direction: row;
          align-items: center;
          .images {
            width: vw(260);
            height: vw(230);
            object-fit: cover;
          }
          .content_box {
            position: relative;
            flex: 1;
            height: vw(230);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-left: vw(30);

            .contents_box {
              margin-top: vw(20);
              margin-bottom: vw(20);
              .contents {
                padding-bottom: vw(5);
                color: #666666;
                font-size: vw(25);
              }
            }
            .content_price {
              position: absolute;
              bottom: 0;
              right: 0;
              color: #ff0000;
              font-size: vw(21);
              span {
                font-size: vw(28);
              }
            }
          }
        }
      }
    }
  }
  .van-list-box {
    .cellView {
      width: 100%;
      text-align: center;
      color: #333333;
      font-size: vw(30);
    }
  }
  .text_line_3 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-height: vw(36);
    // height: vw(72);
    color: #222222;
    font-size: vw(30);
    // font-weight: bold;
    // margin-top: vw(10);
  }
}
</style>
